import Vue from 'vue'
import i18n from './../i18n/i18n'

import { extend, configure, ValidationProvider, ValidationObserver } from "vee-validate";
import { required, numeric,  between, min_value, max_value, regex, length } from "vee-validate/dist/rules";

configure({
  defaultMessage: (field, values) => {
    // override the field name.
    values._field_ = field;

    return i18n.t(`validation.${values._rule_}`, values);
  }
});

extend("required", required);
extend("numeric", numeric);
extend("between", between);
extend("min_value", min_value);
extend("max_value", max_value);
extend("regex", regex);
extend("length", length);

extend("decimal", {
  validate: (value, params) => {
    const separator = '.';
    let decimals = '*';
    if (params !== undefined && params.length > 0) 
    {
      decimals = params[0];
    }

    if (value === null || value === undefined || value === '') {
      return {
        valid: false
      };
    }
    if (Number(decimals) === 0) {
      return {
        valid: /^-?\d*$/.test(value)
      };
    }
    const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`;
    const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`);

    return {
      valid: regex.test(value)
    };
  },
  message: (_, values) => i18n.t('validationcustom.decimal', values)
});

extend("email", {
  validate(value) {
    const EMAILREG = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
    return {
      valid: EMAILREG.test(value)
    };
  },
  message: (_, values) => i18n.t('validationcustom.email', values)
});

extend("phoneNumber", {
  validate(value) {
    const PHONE_NUMBER = /^[0-9]{3}[-|.]?[0-9]{3}(-|.)?[0-9]{4}$/;
    return {
      valid: PHONE_NUMBER.test(value)
    };
  },
  message: (_, values) => i18n.t('validationcustom.phoneNumber', values)
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

